import { render, staticRenderFns } from "./createPaxelRecycleReason.vue?vue&type=template&id=5055e6d5&"
import script from "./createPaxelRecycleReason.vue?vue&type=script&lang=js&"
export * from "./createPaxelRecycleReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports